import { BaseDiv, BaseDivProps } from './BaseDiv';

export const Row = (props: BaseDivProps) => {
  return (
    <BaseDiv {...props} direction="row">
      {props.children}
    </BaseDiv>
  );
};
